import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1420px;
	margin: 0 auto;
	position: relative;
	background-color: ${CSSVars.gray700};
	border-radius: 10px;
	color: ${CSSVars.white};
	display: flex;
	align-items: center;
	gap: 20px;
	flex-direction: column;

	img {
		max-width: 100%;
		height: 100%;
		width: 700px;
	}

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		flex-direction: row-reverse;
	}

	.text-wrapper {
		flex: 1;

		h3 {
			font-weight: 600;
			font-size: ${CSSVars.fontSize2XL};
			max-width: 700px;
			z-index: 10;
			position: relative;

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSize3XL};
			}

			@media screen and (min-width: ${CSSVars.breakpointXL}) {
				font-size: ${CSSVars.fontSize4XL};
			}
		}

		p {
			font-weight: 300;
			font-size: ${CSSVars.fontSizeMD};
			z-index: 10;
			position: relative;
			margin: 20px 0;

			@media screen and (min-width: ${CSSVars.breakpointXL}) {
				margin: 30px 0;
				font-size: ${CSSVars.fontSizeLG};
			}
		}

		a {
			font-weight: 600;
			color: ${CSSVars.white};
			display: flex;
			align-items: center;
			gap: 20px;
			font-size: ${CSSVars.fontSizeLG};
			width: fit-content;

			.icon {
				padding-top: 2px;
			}

			&:hover {
				opacity: 0.8;
				text-decoration: underline;
			}
		}
	}
`;
